export default {
  allowAlignment: false,
  allowButton: false,
  allowHeading: false,
  allowSubheading: false,
  displaySocialBlocksAsButtons: true
};